import { Component, OnInit } from '@angular/core';
import { AuthComponentService } from './auth-component.service';

@Component({
  templateUrl: './auth.component.html'
})
export class AuthComponent implements OnInit {
  urlBrasao: string;

  entidadeCidade: any;

  constructor(private authComponentService: AuthComponentService) {}

  ngOnInit(): void {
    this.urlBrasao = this.authComponentService.getUrlBrasao();
    this.authComponentService
      .getCidade()
      .subscribe(entidadeCidade => (this.entidadeCidade = entidadeCidade));
  }
}
